module.exports = __webpack_public_path__ + "img/teasers_6.f921a5d8.jpg";